export interface VisualEditorZone {
  zoneId: number;
  zoneName: string;
  zoneShortCode: string;
  pageShortCode: string;
  contentType: { id: number; name: "Text" | "Image" };
  content: {
    id: number;
    assetAltText: string | null;
    assetUrl: string | null;
    assetId: number | null;
    assetName: string | null;
    text: string | null;
    hideZone: boolean | null;
  } | null;
}

export enum VisualEditorMessageEventDataType {
  Connect = "connect",
  VerifyInitialZones = "verify-initial-zones",
  SetZoneEditMode = "set-zone-edit-mode",
  EditZoneContent = "edit-zone-content",
  HideZone = "hide-zone",
  RestoreDefaultZoneContent = "restore-default-zone-content",
  ScrollToZone = "scroll-to-zone",
  VerifiedZones = "verified-zones",
  PreviewTabClicked = "preview-tab-clicked",
  Init = "init",
}

export enum VisualEditorConstants {
  BattingCageScript = "batting-cage-script",
}

export interface VisualEditorMessageEvent {
  type: VisualEditorMessageEventDataType;
  context: VisualEditorConstants.BattingCageScript;
  pageZones?: VisualEditorZone[];
  zone?: VisualEditorZone;
  //   editedContent?: any;
  isEditMode?: boolean;
}

export interface VisualEditorState {
  observer: MutationObserver | null;
  previewZoneOverlayElement: Element | null;
  // currentPageZonesList: Element[];
  previewZoneTagsByZoneShortCodeAndZonePageCodeId: Record<string, Element>;
  verifiedZonesByZoneId: Record<number, boolean>;
  defaultZoneContentZoneShortCodeAndZonePageCodeId: Record<
    string,
    Partial<VisualEditorZone["content"]> & {
      ["data-source"]?: string | null;
      ["data-uw-rm-ima-original"]?: string | null;
    }
  >;
  isEditMode?: boolean;
}
